import React from "react"
import {
  RichTextProps,
  TwRichTextField,
} from "../../../root/punks/core/fields/RichTextField"
import classes from "./TypographyTitle.module.css"

export interface TypographyTitleProps extends RichTextProps {
  rootComponent?: string
}

const TypographyTitle = (props: TypographyTitleProps) => {
  const { className, rootComponent, ...other } = props
  return (
    <TwRichTextField
      rootComponent={rootComponent}
      component="p"
      className={classes.root}
      {...other}
    />
  )
}

export default TypographyTitle
